/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */
import React, { useContext, useEffect, useState } from "react";
import { Button } from "reactstrap";
import { ThemeContext } from "../../contexts/ThemeContext";
import ErrorBoundary from "../general/ErrorBoundary";
import GeneralNavbar from "../general/GeneralNavbar";
import PsychometricTestNavbar from '../psychometric/PyschometricTestNavbar';
import { PsychometricContext } from "../../contexts/PsychometricContext";
const PsychometricTestInterestsIntro = ({  
  goToNextStep, 
  goToPreviousStep, 
  history, 
  location,
  isOrganization,
  signedID,
  signedFirstName,
  signedLastName,
  signedOrganization,
  signedEmail,
  ...props  }) => {
  const { theme, fontFamily, colors, fontWeight } = useContext(ThemeContext);
  const [isLoading, setIsLoading] = useState(false);
 const {isStudent} = useContext(PsychometricContext);
  const isIframe = new URLSearchParams(location.search).get('iframe') === 'true';

  useEffect(() => {

    // Validate required parameters based on user type
    if (isOrganization === true) {
      if (!signedOrganization || !signedFirstName || !signedLastName || !signedID) {
        console.log("Redirecting due to missing organization parameters...");
        history.replace("/psychometricSignIn");
        return;
      }
    } else {
      if (!signedEmail) {
        console.log("Redirecting due to missing email...");
        history.replace("/psychometricSignIn");
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [isOrganization, signedEmail, signedID, signedFirstName, signedLastName, signedOrganization,  history]);



  const handleNext = (e) => {
    e.preventDefault();
    console.log("Next Page button clicked");
    goToNextStep();
  };

  const handlePrevious = (e) => {
    e.preventDefault();
    console.log("Previous Page button clicked");
    goToPreviousStep();
  };

  return (
    <div style={{ fontFamily: fontFamily.primary }}>
          {isIframe && (
                <ErrorBoundary errorAt="At PsychometricTestInterestsIntro PsychometricTestNavbar">
                    <PsychometricTestNavbar signedOrganization={signedOrganization} />
                </ErrorBoundary>
            )}
            {!isIframe && (
                <ErrorBoundary errorAt="At General PsychometricTestInterestsIntro GeneralNavbar">
                   <PsychometricTestNavbar signedOrganization={signedOrganization} />
                </ErrorBoundary>
            )}
      <div className="progress" style={{ height: "10px", marginBottom: "10px" }}>
        <div className="progress-bar bg-success" role="progressbar" style={{
          width: "20%",
          background:
            "linear-gradient(to right, #28a745 20%, transparent 20%)",
        }} aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
      <div className="row p-3 px-5">
        <h1 className="col-md-12 col-12 mb-3" style={{
          fontWeight: fontWeight.bold,
          fontSize: "1.5rem",
          color: colors.primaryGreenDark,
        }}>
          DECODING TALENT LANDSCAPE AND PERSONALITY MAPPING
        </h1>
        <h2 className="col-md-12 col-12 mb-3" style={{
          fontWeight: fontWeight.bold,
          fontSize: "1rem",
          color: colors.primaryGreenDark,
        }}>
      {isStudent ? "Building a strong academic culture for success" : "Building a strong workplace culture for success"}
        </h2>

        <div className="col-md-12 col-12 mb-4">
          <h2 style={{ fontWeight: fontWeight.bold, fontSize: "1rem" }}>
            YOUR INTERESTS
          </h2>
          <p style={{ fontSize: "0.8rem" }}>
            Finding a career that allows you to explore or share your interests
            in some way is more likely to keep you engaged, motivated, and
            inspired in your work. In order to choose a career that will give
            you personal satisfaction, you need to spend some time thinking
            about what really interests you. This activity will help you to
            match your interests to different types of careers. For each
            section, select the activities that interest you.
          </p>
        </div>

        <div className="col-md-12 col-12 mb-4 d-flex justify-content-between">

          <Button
            id="next-page"
            type="button"
            color="primary"
            onClick={handleNext}
            disabled={isLoading}
            style={theme.formSubmit}
          >
            {isLoading ? (
              <span className="spinner-border spinner-border-sm mr-1"></span>
            ) : null}
            Next Page
          </Button>
        </div>
      </div>
      <footer style={theme.psychometricTestFooter}>
                Powered by Umang Wellness
        </footer>
    </div>
  );
};

export default PsychometricTestInterestsIntro;
